import React from 'react';

import './FeaturedEventFlagSVG.scss';

export default class FeaturedEventFlagSVG extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {};

    static defaultProps = {};

    render() {
        return (
            <div className="component-Events-FeaturedEventFlagSVG">
                <svg
                    width="30px"
                    height="44px"
                    viewBox="0 0 30 44"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                    <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g id="Verified-flag-with-label">
                            <g id="Group-38">
                                <polygon
                                    id="Path-2"
                                    fill="#EAC9EF"
                                    fillRule="nonzero"
                                    points="0.967078862 0.10678991 0.967078862 43.1067899 15.4670789 34.0137692 29.9670789 43.1067899 29.9670789 0.10678991"
                                />
                                <g
                                    id="Featured"
                                    transform="translate(2.000000, 7.000000)"
                                    fill="#353535"
                                    fontFamily="Lato-BoldItalic, Lato"
                                    fontSize="7"
                                    fontStyle="italic"
                                    fontWeight="bold"
                                >
                                    <text>
                                        <tspan x="0.9105" y="7">
                                            Featured
                                        </tspan>
                                    </text>
                                </g>
                            </g>
                            <path
                                d="M14.2374786,20.5587863 L16.6728551,20.5587863 L15.8815526,19.02352 C15.6002347,19.0235605 15.3139677,19.0236173 15.032672,19.0236957 L14.2374786,20.5587863 Z M14.1240999,21.5823008 L15.4584506,25.5977424 L16.7978912,21.5823008 L14.1240999,21.5823008 Z M19.5133072,20.5587863 L18.4937121,19.0235145 C18.4937121,19.0235145 17.8761273,19.0234202 17.0349008,19.0234314 L17.8302305,20.5587863 L19.5133072,20.5587863 Z M19.3816081,21.5823008 L17.8768477,21.5823008 L16.7676524,24.9075014 L19.3816081,21.5823008 Z M11.5519581,21.5823008 L14.1486481,24.9113306 L13.0381755,21.5823008 L11.5519581,21.5823008 Z M11.3994699,20.5587863 L13.0847926,20.5587863 L13.879734,19.0241822 C13.0410141,19.0246949 12.4249719,19.0255407 12.422403,19.0269192 C12.4179434,19.0293123 11.7874446,19.9758997 11.3994699,20.5587863 Z M10.1093765,20.6435976 L11.5871443,18.4269459 C11.7443414,18.1911502 12.1020394,18 12.3812918,18 L18.5268597,18 C18.8082581,18 19.1644274,18.1920763 19.3210072,18.4269459 L20.798775,20.6435976 C20.9559721,20.8793934 20.9414374,21.2512304 20.768686,21.4710957 L15.7687953,27.834593 C15.5949805,28.0558119 15.3121075,28.0544584 15.1393562,27.834593 L10.1394654,21.4710957 C9.9656506,21.2498769 9.95279669,20.8784673 10.1093765,20.6435976 Z"
                                id="Combined-Shape"
                                fill="#982EA9"
                                fillRule="nonzero"
                            />
                        </g>
                    </g>
                </svg>
            </div>
        );
    }
}
